import React from "react";
import { motion } from "framer-motion";
import { usePublicSettings } from "../contexts/PublicSettingsContext";
import { useLanguage } from "../contexts/LanguageContext";

export const TermsOfService = () => {
  const { settings } = usePublicSettings();
  const { t } = useLanguage();
  const contactEmail = settings.contact_email || "franklytalkingenglish@gmail.com";

  return (
    <main className="pt-24" data-testid="terms-of-service-page">
      <section className="section-padding bg-cream-gradient">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center"
          >
            <span className="badge-orange mb-4 inline-block">{t('legal.badge')}</span>
            <h1 className="font-sora text-4xl md:text-5xl font-bold text-[#1A2E6E] mb-6">
              {t('legal.terms.title')}
            </h1>
            <p className="text-lg text-[#1A2E6E]/70 leading-relaxed">
              {t('legal.terms.intro')}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding bg-warm-texture">
        <div className="container-custom max-w-4xl">
          <div className="glass-card p-8 md:p-10 space-y-8 border-t-4 border-t-[#F5A623]">
            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.servicesTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.servicesBody')}
              </p>
            </section>

            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.bookingTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.bookingBody')}
              </p>
            </section>

            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.accountsTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.accountsBody')}
              </p>
            </section>

            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.paymentsTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.paymentsBody')}
              </p>
            </section>

            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.acceptableUseTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.acceptableUseBody')}
              </p>
            </section>

            <section>
              <h2 className="font-sora text-2xl font-semibold text-[#1A2E6E] mb-3">
                {t('legal.terms.contactTitle')}
              </h2>
              <p className="text-[#1A2E6E]/75 leading-relaxed">
                {t('legal.terms.contactBody')}{" "}
                <a className="text-[#D72B2B] hover:underline" href={`mailto:${contactEmail}`}>
                  {contactEmail}
                </a>.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsOfService;
